import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';

const usePathnameRedirect = () => {
  const history = useHistory();
  const { pathname } = history.location;

  const redirectBasedOnPathname = useCallback(() => {
    if (pathname.startsWith('/benefits')) {
      history.replace('/benefits');
    } else if (pathname.startsWith('/ai')) {
      history.replace('/ai');
    } else if (pathname.startsWith('/task/redeem-benefit') || pathname.startsWith('/redeem-benefit')) {
      history.replace('/');
    }
  }, [pathname, history]);

  return redirectBasedOnPathname;
};

export default usePathnameRedirect;
